import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { ModalComponent, NotifyService, ToastType } from 'app/notify';
import { Company, CompanyId } from '../company.model';
import { WorkRecordRepository } from '../work-record.repository';

@Component({
  selector: 'app-company-modal',
  templateUrl: './company-modal.component.html',
  styleUrls: ['./company-modal.component.scss']
})
export class CompanyModalComponent extends ModalComponent<Company> {

  public title: string = this.translateService.instant('user.modal.company.title');
  public companyForm: FormGroup = null;
  public company: Company = null;

  constructor(
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private notify: NotifyService,
    private workRecordRepository: WorkRecordRepository
  ) {
    super();
  }

  public submit({ valid, value }): void {
    if (!valid) {
     return;
    }

    if (null === this.company.getId()) {
      this.createCompany(value);

      return;
    }

    this.updateCompany(value);
  }

  public setOptions(options: any): void {
    this.createForm();

    if (null !== options.company) {
      this.company = options.company;
      this.companyForm.patchValue(this.company);
    }
  }

  private createCompany(company: Company): void {
    this.workRecordRepository.companyCreate(company)
    .subscribe(
      (response: { id: CompanyId }) => {
        this.close(
          new Company(
            response.id,
            company.name,
            company.tin
          )
        );
        this.notify.toast(ToastType.SUCCESS, this.translateService.instant('create.success'));
      },
      () => {
        this.notify.toast(ToastType.ERROR, this.translateService.instant('create.error'));
      }
    );
  }

  private updateCompany(company: Company): void {
    this.workRecordRepository.companyUpdate(company, this.company.getId())
    .subscribe(
      () => {
        this.close(
          new Company(
            this.company.getId(),
            company.name,
            company.tin
          )
        );
        this.notify.toast(ToastType.SUCCESS, this.translateService.instant('update.success'));
      },
      () => {
        this.notify.toast(ToastType.ERROR, this.translateService.instant('update.error'));
      }
    );
  }

  private clearForm(): void {
    this.companyForm.reset();
  }

  private createForm(): void {
    this.companyForm = this.formBuilder.group({
      name: ['', Validators.required],
      tin: ['', Validators.required]
    });
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/company-modal/company-modal.component.ts